import React from 'react';
import MailActions from 'actions/inbox/MailActions';
import ToastActions from '@store/toast/ToastActions';
import InboxCallSharingDialogContainer from './InboxCallSharingDialogContainer';
import IconButton from 'material-ui/IconButton';
import './ShareToggle.styl';
import {ShareIcon} from '@components/icon/ShareIcon';

export default class ShareToggle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onShare = this.onShare.bind(this);
    this.state = {};
  }
  onClick(e) {
    e.stopPropagation();
    this.setState({sharingDialogToggled: true});
  }
  onShare() {
    this.setState({sharingDialogToggled: false});
    MailActions.saveMailSuccess(this.props.item.set('hasBeenShared', true));
    ToastActions.addToast({
      message: `Successfully shared ${this.props.item.call.description}.`,
    });
  }
  render() {
    const {item} = this.props;
    return (
      <div className="inbox-share-toggle">
        <IconButton onClick={this.onClick}>
          <ShareIcon tooltip="Share call" />
        </IconButton>
        {this.state.sharingDialogToggled && (
          <InboxCallSharingDialogContainer
            open={true}
            fileUploadId={item.call.id}
            onRequestClose={() => this.setState({sharingDialogToggled: false})}
            onShare={this.onShare}
          />
        )}
      </div>
    );
  }
}
